<template>
    <div class="">
        <a href="/new-chk" class="btn btn-cart btn-sm" aria-haspopup="true" aria-expanded="false">
            <span class="badge badge-pill badge-text" style="font-size: 15px;">{{ count }}</span>
            <i class="fas fa-shopping-cart text-dark fa-2x"></i>
        </a>
        <a class="dropdown btn btn-cart btn-sm">
            <i class="fas fa-solid fa-user text-dark fa-2x mr-6" type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="/user-data">會員資料</a>
                <a class="dropdown-item" href="/user-order">購物紀錄</a>
                <a class="dropdown-item" v-on:click="logOut()">登出</a>
            </div>
        </a>
    </div>
</template>
<script>
import axios from 'axios';
import eventHub from '../../library/eventHub';

export default {
    props: {
        text: {
            default: 0
        }
    },
    data() {
        return {
            items: []
        };
    },
    mounted() {
        this.update();
        eventHub.$on('cart:update', this.update);
    },
    destroyed() {
        eventHub.$off('cart:update', this.update);
    },
    methods: {
        update() {
            axios.get(`${base_url}/api/cart`)
                .then((...response_success) => {
                    let response_data = response_success[0].data;
                    try {
                        this.items = [];
                        response_data.forEach(item => this.items.push(item));
                    } catch (e) {
                        console.log(e);
                    }
                    eventHub.$data.cartCount = this.count;
                    return;
                })
                .catch((...response_error) => {
                    console.log(response_error);
                    return;
                });
        },
        logOut: function () {
            axios.get(base_url + '/api/user/logout/' + this.text)
                .then((response) => {
                    if (response.data.message == "Logout success.") {
                        Turbolinks.visit(base_url + '/');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    },
    computed: {
        count() {
            let count = 0;
            this.items.forEach(item => count += item.quantity);
            return count;
        }
    }
}
</script>
<style scoped>
.badge-text {
    color: #535353;
    background-color: #F2CCC5;
}
</style>
